/*
* Resideo/LifeWhere
* Copyright (C) 2018-2023 Resideo/LifeWhere
* mailto:nathan.williams@resideo.com
*/

import React, { Component } from 'react';
import AlertService from '../../services/alerts.service';
import CommentsService from '../../services/comments.service';
import 'react-tabs/style/react-tabs.css';
import memoize from 'memoize-one';
import moment from 'moment';
import { PageView, Event, } from "../GoogleAnalytics";

//import { jsAsset, alertCustomer, jsAlert, jsGraph, jsOpportunity, jsUpdateOpportunity, jsGraphData } from "../../componentObjects";

import TriageAlertsTable from '../TriageAlerts/TriageAlertsTable';
import { TagIdsEnum } from '../../componentObjects';
import alerttypemessagingService from "../../services/alerttypemessaging.service";
import resolvedAlertsService from "../../services/resolvedalertsservice";
import { consolidateAlerts } from "../../utils/alertUtils";

const csvBaseName = "Alert History.csv";

function convertToCSV(jsonArray) {
    let csvRows = [];

    if (!jsonArray || jsonArray.length === 0) {
        return '';
    }

    const headers = ["organizationName", "organization", "alertId", "typeId", "typeName", "severity", "alertMessage", "startTime", "endTime"];
    csvRows.push(headers.join(','));

    for (const obj of jsonArray) {
        const values = headers.map(header => {
            let val;
            
            if (header === "organizationName") {
                val = obj.alert?.organizationName ?? "";
            } else if (header === "organization") {
                val = obj.alert?.organization ?? "";
            } else if (header === "startTime") {
                val = obj.alert?.startTime ?? "";
            } else if (header === "endTime") {
                val = obj.alert?.endTime ?? "";
            } else {
                val = obj[header] ?? ""; // null undefined check
            }
            
            // formatting
            val = String(val).replace(/"/g, '""');
            if (val.includes(',') || val.includes('\n') || val.includes('"')) {
                val = `"${val}"`;
            }
            return val;
        });
        csvRows.push(values.join(','));
    }

    return csvRows.join('\n');
}

function downloadCSV(data) {
    Event("Download Data Clicked", "User clicked download data button in Monitor Alert History", "Download Data Clicked");
    
    const csvContent = "data:text/csv;charset=utf-8," + encodeURIComponent(convertToCSV(data));

    const link = document.createElement("a");
    link.setAttribute("href", csvContent);
    link.setAttribute("download", csvBaseName || "data.csv");
    document.body.appendChild(link);
    link.click();
}

class AlertHistory extends Component {
    static displayName = AlertHistory.name;
    _isMounted = false;

    constructor(props) {
        super(props);

        this.getAlerts = this.getAlerts.bind(this);
        this.changeRadio = this.changeRadio.bind(this);
        this.reloadTable = this.reloadTable.bind(this);
        this.filterAlerts = this.filterAlerts.bind(this);
        this.consolidateAlerts = this.consolidateAlerts.bind(this);
        this.addConversationToAlert = this.addConversationToAlert.bind(this);
        this.updateAlertList = this.updateAlertList.bind(this);
        this.handleDownloadData = this.handleDownloadData.bind(this);

        this.state = {
            alertArgs: {
                queryId: "custom",
                startTime: null,
                endTime: null,
                isActive: true,
                priority: 3
            },
            alertType: "Active",
            alertList: [],
            loading: true,
            alertTableLoading: false,
            alertMessaging: [],
            assetComments: [],
            partnerInfo: {},
            tableObj: {},
            startTabIndex: 0,
            consolidateAlertsDict: {},
            resolvedAlerts: []
        }
    }

    async componentDidMount() {
        this._isMounted = true;
        PageView();
        this.getAlerts();
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.currentCustomerId !== this.props.currentCustomerId) {
           this.getAlerts();
        }
    }
    componentWillUnmount() {
        this._isMounted = false;
    }

    memAlerts = memoize(this.getAlerts);

    async getAlerts(id, start = null, end = null) {
        let startTime = performance.now();
        let now = (end == null ? moment() : end);
        let before = (start == null ? moment(now).subtract(1, 'months') : start);
        let nowStr = now.format();
        let beforeStr = before.format();
        let nowutcStr = now.utc().format();
        let beforeutcStr = before.utc().format();
        let startTabIndex = 0;
        let alertList = [];

        if (this._isMounted)
            this.setState(prevState => ({
                alertTableLoading: true,
                alertArgs: {
                    ...prevState.alertArgs,
                    startTime: beforeStr,
                    endTime: nowStr
                }
            }), async () => {
                await resolvedAlertsService.getAllResolvedAlerts()
                    .then(response6 => {
                        if (this._isMounted && response6 !== null && response6 !== undefined) {
                            this.setState({ resolvedAlerts: response6 });
                        }
                        else {
                            this.setState({ resolvedAlerts: [] });
                        }
                    })
                    .catch(e => {
                        console.log(e);
                    })
                await alerttypemessagingService.getpartnermessaging(this.props.currentPartnerId)
                    .then(response3 => {
                        if (this._isMounted)
                            this.setState({ alertMessaging: response3 }, async () => {
                                await CommentsService.getassetcomments()
                                .then(response4 => {
                                    this.setState({ assetComments: response4.data }, async () => {
                                        let request = {
                                            startTime: beforeutcStr,
                                            endTime: nowutcStr,
                                            organizationId: this.props.currentCustomerId,
                                            partnerOrganizationId: this.props.currentPartnerId,
                                            ignoreIsClosed: false
                                        };
                                        await AlertService.gethistoricalalertslist(request)
                                        .then(response5 => {
                                            if (this._isMounted)
                                                this.setState({ tableObj: response5.data }, () => {

                                                    let filteredEquipAlertList = this.state.tableObj.equipmentAlertsList !== undefined && this.state.tableObj.equipmentAlertsList !== null ? this.state.tableObj.equipmentAlertsList.filter(a => (a.alert.tagIds.includes(TagIdsEnum.JobCreated) == false) && a.alert.isMuted == false) : [];


                                                    if (filteredEquipAlertList.length > 0) {
                                                        alertList = filteredEquipAlertList;
                                                        startTabIndex = 0;
                                                    }
                                                    else {

                                                        alertList = this.state.tableObj.deviceAlertsList !== null ? this.state.tableObj.deviceAlertsList.filter(a => a.alert.tagIds.includes(TagIdsEnum.JobCreated) == false && a.alert.isMuted == false) : [];
                                                        startTabIndex = 1;
                                                    }
                                                    this.setState({ loading: true, alertTableLoading: true, startTabIndex: startTabIndex }, () => {
                                                        this.consolidateAlerts(alertList);
                                                    });
                                                });
                                        })
                                            .catch(e => {
                                                console.log(e);
                                                this.setState({ loading: false, alertTableLoading: false });
                                            })
                                    })
                                })
                                    .catch(e => {
                                        console.log(e);
                                        this.setState({ loading: false, alertTableLoading: false });
                                    })
                            });
                    })
                    .catch(e => {
                        console.log(e);
                        this.setState({ loading: false, alertTableLoading: false });
                    });
            });

    }

    consolidateAlerts(alerts) {
        const isDeviceHealthAlerts = this.state.startTabIndex === 1;
        const { distinctAlerts, consolidatedAlertsDict } = consolidateAlerts(alerts, isDeviceHealthAlerts);

        if (this._isMounted) {
            this.setState({ alertList: distinctAlerts, consolidateAlertsDict: consolidatedAlertsDict, loading: false, alertTableLoading: false });
        }         
    }

    async filterAlerts(tabIndex, radio, isActive, isScheduled, selectedTypes) {
        if (this.state.tableObj.equipmentAlertsList !== null && this.state.tableObj.equipmentAlertsList !== undefined && this._isMounted)
            this.setState({ alertTableLoading: true }, () => {
                let alerts = tabIndex == 0 ? this.state.tableObj.equipmentAlertsList : this.state.tableObj.deviceAlertsList;

                if (radio === "Critical")
                    alerts = alerts.filter(a => a.severity === "Critical");
                else if (radio === "Warning")
                    alerts = alerts.filter(a => a.severity === "Warning");

                if (isActive !== null) {
                    if (isActive == true)
                        alerts = alerts.filter(a => a.alert.isActive == true);
                    else
                        alerts = alerts.filter(a => a.alert.isActive == false);
                }

                if (isScheduled !== null) {
                    if (isScheduled == true)
                        alerts = alerts.filter(a => a.alert.isMuted == true);
                    else
                        alerts = alerts.filter(a => a.alert.isMuted == false);
                }

                this.consolidateAlerts(alerts); //this.setState({ alertList: alerts, alertTableLoading: false });  
            });
    }

    async reloadTable(useCache, months) {
        if (this._isMounted) {
            this.setState({
                alertTableLoading: true,
                alertList: []
            });

            this.setState(prevState => ({
                alertArgs: {
                    ...prevState.alertArgs,
                    isActive: this.state.alertType === "Inactive" ? false : true
                }
            }));
            let endDate = moment();
            let startDate = moment(endDate).subtract(months, 'month');
            await this.getAlerts(0, startDate, endDate);
        }
    }

    async changeRadio(val) {
        let x = val;
        Event("Alert History Radio Clicked", "User clicked one of the radio buttons for the alert table in Alert History", "ALert History Radio Clicked");

        if (this._isMounted) {
            this.setState({
                alertType: x,
                alertList: []
            });

            this.setState(prevState => ({
                alertArgs: {
                    ...prevState.alertArgs,
                    isActive: x === "Inactive" ? false : true
                }
            }));

            this.setState({ alertTableLoading: true }, async () => {
                await this.getAlerts();
            });
        }
    }

    addConversationToAlert(conversationId, alertId) {
        var index = 0;
        var alert = null;

        index = this.state.tableObj.alerts.findIndex(a => {
            return a.alertId === alertId;
        });

        var tempTableObj = [...this.state.tableObj.alerts];
        alert = { ...tempTableObj[index] };
        alert.conversationId = conversationId.toString();
        tempTableObj[index] = alert;

        if (this._isMounted)
            this.setState(prevState => ({
                tableObj: {
                    ...prevState.tableObj,
                    alerts: tempTableObj
                }
            }));
    }

    updateAlertList(alertsTable) {
        if (this._isMounted)
            this.setState({ alertList: alertsTable });
    }

    handleDownloadData() {
        downloadCSV(this.state.alertList);
    }

    render() {
        const { classes } = this.props;

        let downloadBtn =
            <div className="row no-gutters alerts-tab-wrapper margin-0-20 pad-10-0">
                <div className="btn-right pad-30">
                    <button className="primary-btn btn-large width-150" onClick={this.handleDownloadData} disabled={this.state.loading || this.state.alertTableLoading}>Download Data</button>
                </div>
            </div>;
        
        return (
            <div sx={(theme)=>({
                [theme.breakpoints.down('md')]: {
                    marginLeft: '-225px !important',
                },
            })}>
                <div className="infoPage">
                    <h2 className="pageTitle dashboard-title" id="tabelLabel">
                        Alert History
                    </h2>
                    {downloadBtn}
                    <TriageAlertsTable alertList={this.state.alertList} startTabIndex={this.state.startTabIndex} _isMounted={this._isMounted} loading={this.state.loading} alertTableLoading={this.state.alertTableLoading} alertMessaging={this.state.alertMessaging} assetComments={this.state.assetComments} tableObj={this.state.tableObj}
                        filterAlerts={this.filterAlerts} reloadTable={this.reloadTable} customers={this.props.customers} consolidateAlertsDict={this.state.consolidateAlertsDict} addConversationToAlert={this.addConversationToAlert} userOrg={this.props.userOrg} updateAlertList={this.updateAlertList}
                        setActivePath={this.props.setActivePath} source="AlertHistory" updateSearch={this.getAlerts} resolvedAlerts={this.state.resolvedAlerts} customerId={this.props.currentCustomerId}/>
                </div>
            </div>
        );
    }
}

export default AlertHistory;